export default {
  API_PREFIX: '/user',
};
